import { InputBase as MantineInputBase, InputBaseProps } from '@mantine/core';

export type IInputBaseProps = InputBaseProps;

/** @registry Design-layer pass-through over Mantine InputBase; import this instead of @mantine/core InputBase outside src/design. Extend here when InputBase needs house behavior. */
export const InputBase = MantineInputBase;
